<div class="row">
    <div class="col-12">
        <div class="row" >
            <div class="col-lg-3 col-md-3 col-xs-12 col-sm-12">
            <ul>
                <li *ngFor="let mn of menu">
                   <a href="javascript:void(0)" [routerLink]="['/agence',mn.url]" routerLinkActive="router-link-active" > {{mn.title}}</a> 
                </li>
            </ul>
            </div>
            <div class="col-lg-9 col-md-9 col-xs-12 col-sm-12">
              
                <div class="row">
                    <router-outlet></router-outlet>
                </div>
               
            </div>
     
        </div>
    </div> 
</div>
